export const DESKTOP_SIZE_BREAKPOINT_MIN = 1200;
export const TABLET_SIZE_BREAKPOINT_MAX = 1199.99;
export const TABLET_SIZE_BREAKPOINT_MIN = 576;
export const MOBILE_SIZE_BREAKPOINT_MAX = 575.99;
export const SMALL_MOBILE_SIZE_BREAKPOINT_MAX = 350;
export const LARGE_MOBILE_SIZE_BREAKPOINT_MAX = 400;